








import { defineComponent, watch } from '@nuxtjs/composition-api';
import { UCIcon } from '@shared/ui';

export default defineComponent({
  name: 'UCModal',
  components: {
    UCIcon,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    function disableBodyScroll() {
      document.body.classList.add('uc-modal--open');
    }

    function enableBodyScroll() {
      document.body.classList.remove('uc-modal--open');
    }

    function onClose() {
      emit('close');
    }

    watch(
      () => props.open,
      () => {
        if (typeof document === 'undefined') {
          return;
        }

        if (props.open) {
          disableBodyScroll();
        } else {
          enableBodyScroll();
        }
      },
      { immediate: true },
    );

    return {
      onClose,
    };
  },
});
